"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDirectoryContext = void 0;
const react_1 = require("react");
exports.UserDirectoryContext = (0, react_1.createContext)({});
